module.exports = __webpack_public_path__ + "img/3-1.da6dfaab.svg";